// Module
var code = "<div ng-if=\"heading\" class=\"panel-heading\">{{heading}}</div> <div class=\"panel-body\" ng-transclude></div>";
// Exports
module.exports = code;